import { render, staticRenderFns } from "./SuggestionCU.vue?vue&type=template&id=21557e29"
import script from "./SuggestionCU.vue?vue&type=script&lang=js"
export * from "./SuggestionCU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports